const subscriptions = { }
const getNextUniqueId = getIdGenerator()

const subscribe = (eventType, callback) => {
    const id = getNextUniqueId()

    if(!subscriptions[eventType])
        subscriptions[eventType] = { }

    subscriptions[eventType][id] = callback

    return { 
        unsubscribe: () => {
            delete subscriptions[eventType][id]
            if(Object.keys(subscriptions[eventType]).length === 0) delete subscriptions[eventType]
        }
    }
}

const publish = (eventType, arg) => {
    if(!subscriptions[eventType])
        return

    Object.keys(subscriptions[eventType]).forEach(key => subscriptions[eventType][key](arg))
}

function getIdGenerator() {
    let lastId = 0
    
    return function getNextUniqueId() {
        lastId += 1
        return lastId
    }
}

const NEW_TASK = "newTask"
const UPDATE_TASK = "updateTask"
const DELETE_TASK = "deleteTask"

const NEW_INVOICE = "newInvoice"
const UPDATE_INVOICE = "updateInvoice"
const DELETE_INVOICE = "deleteInvoice"

const NEW_TICKET = "newTicket"
const UPDATE_TICKET = "updateTicket"
const DELETE_TICKET = "deleteTicket"

export default { 
    subscribe, publish, 
    NEW_TASK, UPDATE_TASK, DELETE_TASK,
    NEW_INVOICE, UPDATE_INVOICE, DELETE_INVOICE,
    NEW_TICKET, UPDATE_TICKET, DELETE_TICKET
}